var _excluded = ["label", "isDisabled", "defaultIsChecked", "value", "onChange", "size", "isViewMode", "isReadOnly", "isInvalid", "autoFocus", "aria-label", "aria-required"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { uniqueId } from 'lodash';
import { useState } from 'react';
import { forwardRef } from '../../../utils';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { Box } from '../../internal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Switch = forwardRef((props, ref) => {
  var _ref;

  var {
    label,
    isDisabled,
    defaultIsChecked = false,
    value,
    onChange,
    size,
    isViewMode,
    isReadOnly,
    isInvalid,
    autoFocus,
    'aria-label': ariaLabel,
    'aria-required': ariaRequired
  } = props,
      rest = _objectWithoutProperties(props, _excluded);

  var [isChecked, setIsChecked] = useState(defaultIsChecked);
  var id = uniqueId('switch_');
  var styles = useMultiStyleConfig('Switch', {
    size
  });
  var isCheckedValue = value !== null && value !== void 0 ? value : isChecked;

  var handleChange = event => {
    setIsChecked(event.target.checked);
    onChange === null || onChange === void 0 ? void 0 : onChange(event.target.checked);
  };

  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({}, rest), {}, {
    "data-component": "Switch",
    ref: ref,
    __css: styles['container'],
    "aria-disabled": isDisabled,
    as: "label" // ts-ignore is used due to `type` issues with `<Box/>`.
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    ,
    htmlFor: id,
    children: [label && /*#__PURE__*/_jsx(Box, {
      as: "span",
      __css: styles['label'],
      "aria-disabled": isDisabled,
      children: label
    }), /*#__PURE__*/_jsxs(Box, {
      __css: styles['switch'],
      children: [/*#__PURE__*/_jsx(Box, {
        as: "input",
        id: id // ts-ignore is used due to `type` issues with `<Box/>`.
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        ,
        type: "checkbox",
        onChange: handleChange,
        onClick: event => event.stopPropagation(),
        disabled: isDisabled,
        role: "switch" // Use `aria-label` if provided, otherwise use `label` or default to 'Switch'. to ensure a correct screen reader experience.
        ,
        "aria-label": (_ref = ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : label) !== null && _ref !== void 0 ? _ref : 'Switch',
        "aria-checked": isCheckedValue,
        checked: isCheckedValue,
        "data-testid": "switch-input",
        autoFocus: autoFocus,
        "aria-required": ariaRequired
      }), /*#__PURE__*/_jsx(Box, {
        as: "span",
        __css: styles['slider'],
        "data-checked": isCheckedValue || undefined,
        "data-disabled": isDisabled || undefined
      })]
    })]
  }));
});
Switch.displayName = 'Switch';
//# sourceMappingURL=Switch.js.map